import { PhotoJobTypes } from 'models/AvailablePhotoJobTypes';
import { useEffect, useState } from 'react';
import { fetchAvailablePhotoJobTypes } from 'api/photo-session';

const useAvailablePhotoJobTypes = (propertyId) => {
  const [availableTypes, setAvailableTypes] = useState([
    PhotoJobTypes.FIXED,
  ]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (propertyId) {
      setLoading(true);
      fetchAvailablePhotoJobTypes(propertyId)
        .then((res) => {
          setLoading(false);
          setAvailableTypes(res.availableTypes);
        })
        .catch((err) => {
          setLoading(false);
          setError(err);
        });
    }
  }, [propertyId]);

  return { availableTypes, error, loading };
};

export default useAvailablePhotoJobTypes;
